import { useEffect, useState } from "react"
import { SignInForm } from "./components/signin-form"
import Auth from "middleware"
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";


export const SignIn = () => {

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = new Cookies().get('token');

  useEffect(() => {
    const fetchUser = async () => {
      const result = await Auth(token);
      setUser(result);
      setLoading(false);
    };
    fetchUser();

  }, [token]);

  useEffect(() => {
    if (!loading && user !== null) {
        navigate('/profile');
    }
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-screen h-screen flex bg-black items-center text-white">
      <div className="w-1/2 h-full flex items-center justify-center">
        <div className="w-[70%]">
          <SignInForm />
        </div>
      </div>
      <div id="right" className="w-1/2 flex justify-center items-center">
        <div id="logo" className="mx-auto">
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            className="w-[35vw]"
            viewBox="0 0 24 24" version="1.1">
            <title>code_fill</title>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Development" transform="translate(0.000000, -48.000000)" fillRule="nonzero">
                <g id="code_fill" transform="translate(0.000000, 48.000000)">
                  <path
                    d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                    id="MingCute" fillRule="nonzero">

                  </path>
                  <path
                    d="M13.476,3.629 C14.2918,3.77285 14.8365,4.55084 14.6927,5.36668 L12.2616,19.154 C12.1178,19.9698 11.3398,20.5146 10.5239,20.3707 C9.7081,20.2269 9.16334,19.4489 9.3072,18.633 L11.7383,4.84574 C11.8821,4.02989 12.6601,3.48514 13.476,3.629 Z M7.56063,6.69652 C8.14641,7.2823 8.14641,8.23205 7.56063,8.81784 L4.37864,11.9998 L7.56063,15.1818 C8.14641,15.7676 8.14641,16.7173 7.56063,17.3031 C6.97484,17.8889 6.02509,17.8889 5.4393,17.3031 L1.19666,13.0605 C0.915359,12.7792 0.757324,12.3976 0.757324,11.9998 C0.757324,11.602 0.915359,11.2205 1.19666,10.9392 L5.4393,6.69652 C6.02509,6.11073 6.97484,6.11073 7.56063,6.69652 Z M18.5606,6.69652 L22.8033,10.9392 C23.0846,11.2205 23.2426,11.602 23.2426,11.9998 C23.2426,12.3976 23.0846,12.7792 22.8033,13.0605 L18.5606,17.3031 C17.9748,17.8889 17.0251,17.8889 16.4393,17.3031 C15.8535,16.7173 15.8535,15.7676 16.4393,15.1818 L19.6213,11.9998 L16.4393,8.81784 C15.8535,8.23205 15.8535,7.2823 16.4393,6.69652 C17.0251,6.11073 17.9748,6.11073 18.5606,6.69652 Z"
                    id="形状" fill="#F58308">
                  </path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  )
}
